import { render } from "./ViewUsagerPage.vue?vue&type=template&id=5f4fda1e&ts=true"
import script from "./ViewUsagerPage.vue?vue&type=script&lang=ts"
export * from "./ViewUsagerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__